import { useState } from 'react';

import PriceComparison from './PriceComparison';
export default function PricecomparePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="PricecomparePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><PriceComparison /></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
